import { AxiosResponse } from 'axios';
import client from './clientRetryable';
import getAuthHeader from '@/util/getAuthHeader';
import moment from 'moment-timezone';

export default {
  async fetch(id: number): Promise<AxiosResponse<Response>> {
    return await client.get<Response>(`/kyc_requests/${id}/kyc_request_informations/masked_information`, {
      headers: getAuthHeader()
    });
  }
};

export interface Response {
  lastName: string;
  middleName: string;
  firstName: string;
  birthday: string;
  zipCode: string;
  maskedAddress1: string;
  maskedAddress2: string;
  maskedAddress3: string;
  maskedAddress4: string;
}
